module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Mono.9c1f0f88.ttf";